import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../api';
import { IChangePassword, IUser, IUpdateUserProfile } from './interface';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getCurrentUser: builder.query<IUser, string>({
      query: () => ({
        url: `/users/me`,
        method: 'GET',
      }),
      providesTags: ['User'],
    }),
    updateUserProfile: builder.mutation<IUser, Record<string, string>>({
      query: (body) => ({
        url: '/users/me',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['User'],
    }),
    updateUserAvatar: builder.mutation<IUser, FormData>({
      query: (formData) => ({
        url: '/users/me/avatar',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['User'],
    }),
    changeUserPassword: builder.mutation<string, IChangePassword>({
      query: (body) => ({
        url: `/auth/change-password`,
        method: 'POST',
        body: {
          current_password: body.old_password,
          new_password: body.new_password,
        },
      }),
    }),
    deactivateAccount: builder.mutation<'', {}>({
      query: (body) => ({
        url: `/users/deactivate-account`,
        method: 'PATCH',
        body,
      }),
    }),
  }),
});

export const { 
  useGetCurrentUserQuery, 
  useUpdateUserProfileMutation,
  useUpdateUserAvatarMutation,
  useChangeUserPasswordMutation, 
  useDeactivateAccountMutation 
} = userApi;